import { Grid } from "@mui/material";
import Condition from "../../../../components/condition/Condition";
import useGenerateOptions from "../../../../components/input/hook/useGenerateOptions2";
import { useGetPaymentMethods } from "../../api/invoice/paymentMethod/resolver";
import { M_InvoiceConstant } from "../../type/Invoice.type";
import Input from "../../../../components/input/Input-v2";

interface PaymentMethodInput {
  isPaymentForm: boolean;
  invoice_status: string;
  dataInvoiceConstant: M_InvoiceConstant | undefined;
  control: any;
  disable?: boolean;
}

export default function PaymentMethodInput({
  isPaymentForm,
  control,
  dataInvoiceConstant,
  invoice_status,
  disable,
}: PaymentMethodInput) {
  const { data: dataRawPaymentMethods, isLoading: fetchPaymentMethod } =
    useGetPaymentMethods({});
  const dataPaymentMethods = dataRawPaymentMethods?.data.data.data;
  const { data: dataPaymentMethodOptions } = useGenerateOptions({
    dataSource: dataPaymentMethods,
    keyForText: "payment_method_name",
    keyForValue: "id",
  });
  const condition = isPaymentForm
    ? true
    : invoice_status !== undefined &&
      invoice_status === dataInvoiceConstant?.status.Lunas;

  return (
    <Condition.IF condition={condition}>
      <Grid item xs={12} md={12}>
        <Input.Controller
          control={control}
          name="payment_method_id"
          render={(field, fieldState) => (
            <Input.Select
              disable={disable}
              showAsStatic={disable}
              isFetching={fetchPaymentMethod}
              label="Jenis Pembayaran"
              options={dataPaymentMethodOptions}
              value={field.value}
              onChange={(e) => field.onChange(e.value)}
              error={fieldState.error?.message}
            />
          )}
        />
      </Grid>
    </Condition.IF>
  );
}
